// extracted by mini-css-extract-plugin
export var closeButton = "_8n-0";